import { ISidebarCssProvider } from './sidebar-css-provider.interface';

export abstract class SidebarCssProviderBase implements ISidebarCssProvider {
    public abstract getBaseCssFiles(): string[];
}
